var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { datadogRum } from '@datadog/browser-rum';
import logger from '../../config/app.logger';
import { getExtendedLogger } from '../Logger';
import { IGNORABLE_ERROR_PATTERNS, LOGGER_NAME, GENERIC_CONTEXT } from './constants';
var log = getExtendedLogger(LOGGER_NAME, logger);
function __add_context__(ctxname, ctx) {
    return datadogRum.addRumGlobalContext(ctxname, ctx);
}
function __set_context__(ctxname, ctx) {
    var _a;
    var globalContext = datadogRum.getRumGlobalContext();
    return datadogRum.setRumGlobalContext(__assign(__assign({}, globalContext), (_a = {}, _a[ctxname] = ctx, _a)));
}
function updateContext(ctxname, ctx) {
    log('updating %s datadog context with %o', ctxname, ctx);
    var globalContext = datadogRum.getRumGlobalContext();
    globalContext[ctxname] ? __set_context__(ctxname, ctx) : __add_context__(ctxname, ctx);
    log('successfully updated %s datadog context', ctxname);
}
function removeContext(ctxname) {
    log('removing %s datadog context', ctxname);
    var globalContext = datadogRum.getRumGlobalContext();
    if (globalContext[ctxname]) {
        delete globalContext[ctxname];
        datadogRum.setRumGlobalContext(globalContext);
    }
    log('removed %s datadog context', ctxname);
}
function identifyUser(user) {
    log('setting datadog user: ', user);
    datadogRum.setUser({
        id: user.id,
    });
    log('datadog successfully set');
}
function clearUser() {
    log('removing datadog user');
    datadogRum.removeUser();
    log('datadog user successfully removed');
}
function initDatadog(options) {
    log('initialising with options %o', options);
    datadogRum.init(__assign(__assign({}, options), { beforeSend: function (event, context) {
            var _a;
            if (event.type === 'error' && IGNORABLE_ERROR_PATTERNS.includes(event.error.message)) {
                return false;
            }
            return (_a = options.beforeSend) === null || _a === void 0 ? void 0 : _a.call(options, event, context);
        } }));
    log('successfully initialised');
}
function updateShellContext(ctxname, ctxvalue) {
    var _a;
    var globalContext = datadogRum.getRumGlobalContext();
    var shellContext = globalContext[GENERIC_CONTEXT];
    var ctx = (_a = {}, _a[ctxname] = ctxvalue, _a);
    if (shellContext) {
        __set_context__(GENERIC_CONTEXT, __assign(__assign({}, shellContext), ctx));
    }
    else {
        __add_context__(GENERIC_CONTEXT, ctx);
    }
}
function sendActionToDatadog(name, context) {
    try {
        datadogRum.addAction(name, context);
    }
    catch (error) {
        console.error(error); //eslint-disable-line no-console
    }
}
function sendCustomTimingToDatadog(name, time) {
    try {
        datadogRum.addTiming(name, time);
    }
    catch (error) {
        console.log(error); //eslint-disable-line no-console
    }
}
export { updateContext, identifyUser, clearUser, removeContext, initDatadog, updateShellContext, sendActionToDatadog, sendCustomTimingToDatadog, };
//# sourceMappingURL=helpers.js.map